import { useSearchParams } from "react-router-dom";
import { Flex, Typography, Button, theme } from "antd";
import {
  Loading3QuartersOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
const { Title } = Typography;

import "./style.scss";
const styleWrapperClass = "error-landing";

import FloatingCard from "../../../components/Shared/FloatingCard";

export default function CFDIFileLanding() {
  const { token: theme_token } = theme.useToken();

  const [searchParams] = useSearchParams();

  const e = searchParams.get("e");
  let response = null;

  const nonErrorCodes = ["loading_xml", "canceled_no_xml"];

  if (!nonErrorCodes.includes(e)) {
    response = (
      <Flex
        justify="center"
        align="center"
        vertical
        style={{ marginTop: "50px" }}
      >
        <FloatingCard>
          <Flex align="center" vertical gap={15}>
            <Title level={3} style={{ textAlign: "center" }}>
              No pudimos abrir el archivo solicitado, inténtalo más tarde.
            </Title>
            <Button type="primary" danger onClick={() => window.close()}>
              Cerrar ventana
            </Button>
          </Flex>
        </FloatingCard>
      </Flex>
    );
  } else if (e === "loading_xml") {
    response = (
      <Flex
        justify="center"
        align="center"
        vertical
        style={{ marginTop: "50px" }}
      >
        <FloatingCard>
          <Flex align="center" vertical gap={15}>
            <Loading3QuartersOutlined
              spin
              style={{ fontSize: "40px", color: theme_token.colorPrimary }}
            />
            <Title level={3} style={{ textAlign: "center" }}>
              Tu archivo se está descargando, inténtalo más tarde.
            </Title>
            <Button type="primary" danger onClick={() => window.close()}>
              Cerrar ventana
            </Button>
          </Flex>
        </FloatingCard>
      </Flex>
    );
  } else if (e === "canceled_no_xml") {
    response = (
      <Flex
        justify="center"
        align="center"
        vertical
        style={{ marginTop: "50px" }}
      >
        <FloatingCard>
          <Flex align="center" vertical gap={15}>
            <CloseCircleOutlined
              style={{ fontSize: "40px", color: theme_token.colorError }}
            />
            <Title level={3} style={{ textAlign: "center" }}>
              El CFDI ya está cancelado y no se puede recuperar el archivo.
            </Title>
            <Button type="primary" danger onClick={() => window.close()}>
              Cerrar ventana
            </Button>
          </Flex>
        </FloatingCard>
      </Flex>
    );
  }

  return <div className={styleWrapperClass}>{response}</div>;
}
